import React from 'react'
import './style.sass'
import PropTypes from 'prop-types'
import FieldWrapper from '../FieldWrapper'

const TextField = ({ type = "text" , displayName, placeholder, description, errorMessage, disabled, value, onChange }) => {
  return (
    <FieldWrapper
      displayName={displayName}
      description={description} 
      errorMessage={errorMessage}
      disabled={disabled}
    >
      <div className="text-field-container">
        <input
          type={type}
          placeholder={placeholder || displayName}
          value={value ?? ""}
          onChange={onChange ? (e) => onChange(e.target.value) : () => {}}
          disabled={disabled}
        />
      </div>
    </FieldWrapper>
  )
}

TextField.propTypes = {
  type: PropTypes.oneOf(['text', 'email', 'number', 'password']),
  displayName: PropTypes.string,
  placeholder: PropTypes.string,
  description: PropTypes.string,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.any,
  onChange: PropTypes.func,
}

export default TextField
